import { ITariffZone } from '../../../../models/tariff-zone.model';

export class TariffZoneApiModel {
  public static mapToBusinessModel(apiModel: TariffZoneApiModel): ITariffZone {
    return {
      name: apiModel.name ?? '',
      number: apiModel.number,
      shortName: apiModel.shortName ?? '',
    };
  }

  public gid?: string;
  public name?: string;
  public number!: number;
  public shortName?: string;
}
